import IVendorConfig from "src/environments/Ivendor-config";
import {vendorConfigFr} from '../../environments/vendor.config';

export function insightMapper(config: IVendorConfig, use: string){
  if(use === 'edu') {
    config.primaryUseOptionsToDisplay = ["Education"];
  }

  config.showFlexLink = true;
  config.flexLinkUrl = "https://www.insight.com/en_US/shop/partner/google/google-chrome-os/get-chromeos-flex.html#free-trial"

  config.countriesThatRequireOptIn = [
    "ca",
    "us"
  ];
  config.brandsOptionsToDisplay = [
    "Lenovo",
    "Acer",
    "ASUS",
    "Dell",
    "HP",
    "Samsung"
  ];

  config.informationWorkerRequiresFingerprintSensor = true;
  config.informationWorkerRequiresPrivacyScreen = true;
  config.informationWorkerRequiresBacklitKeyboard = true;

  config.executiveMobileWorkerRequiresFingerprintSensor = true;
  config.executiveMobileWorkerRequiresPrivacyScreen = true;
  config.executiveMobileWorkerRequiresBacklitKeyboard = true;
  config.executiveMobileWorkerRequiresStylus = true;

  config.showSaveResultsButton = true;
  config.showShareResultsButton = true;
  config.showInStockInfo = true;
}

export function insightFrMapper(config: IVendorConfig){
  config = vendorConfigFr;

  config.informationWorkerRequiresFingerprintSensor = true;
  config.informationWorkerRequiresPrivacyScreen = true;
  config.informationWorkerRequiresBacklitKeyboard = true;

  config.executiveMobileWorkerRequiresFingerprintSensor = true;
  config.executiveMobileWorkerRequiresPrivacyScreen = true;
  config.executiveMobileWorkerRequiresBacklitKeyboard = true;
  config.executiveMobileWorkerRequiresStylus = true;

  config.showSaveResultsButton = true;
  config.showShareResultsButton = true;
  config.showInStockInfo = true;
  return config;
}


